import styled from 'styled-components';

const MyDiv = styled.div`

`;

export default MyDiv;
